import React from 'react';
import TennisComp from './Tennis.component';

class Tennis extends React.Component {
    componentDidMount() {
        TennisComp();
    }
    render() {
        return (
            <div>
            </div>
        )
    }
}

export default Tennis;